<script lang="ts" setup>

</script>

<template>
    <div class="rich-response-list-item-group">
        <slot />
    </div>
</template>

<style lang="scss" scoped>
.rich-response-list-item-group {
    margin-top: 0.5em;

    > * {
        margin-top: 0;
        margin-bottom: 0;

        &:first-child {
            &::part(native) {
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
            }
        }

        &:last-child {
            &::part(native) {
                border-top-left-radius: 0;
                border-top-right-radius: 0;
            }
        }

        &:not(:first-child):not(:last-child) {
            &::part(native) {
                border-radius: 0;
            }
        }
    }
}
</style>
